import { PriceModuleModalEnum } from '@inter-ikea-kompis/component-price-module';
import { ProductInformationSectionModalEnum } from '@inter-ikea-kompis/component-product-information-section';
import { StoreSelectorModalEnum } from '@inter-ikea-kompis/component-store-selector';
import { ZipInModalEnum } from '@inter-ikea-kompis/component-zip-in';

import ProductCardTakeBackReturnInformationModalEnum from './ProductCardTakeBackReturnInformationModalEnum.js';

enum ProductCardModalEnum {
	energyLabelCard = PriceModuleModalEnum.energyLabelCard,
	ecoFeeCard = PriceModuleModalEnum.ecoFeeCard,
	energyFicheCard = PriceModuleModalEnum.energyFicheCard,
	storeSelectorCard = StoreSelectorModalEnum.storeSelectorCard,
	unifiedWaterLabelCard = PriceModuleModalEnum.unifiedWaterLabelCard,
	productDetailsCard = ProductInformationSectionModalEnum.productDetailsCard,
	technicalInformationCard = ProductInformationSectionModalEnum.technicalInformationCard,
	measurementsCard = ProductInformationSectionModalEnum.measurementsCard,
	zipIn = ZipInModalEnum.zipIn,
	takeBackReturnQrCard = ProductCardTakeBackReturnInformationModalEnum.takeBackReturnQrCard
}

export default ProductCardModalEnum;
